import Tbanner from '@/components/user/race-events/race-components/web-banner-2022.vue';
export default {
    name: 'SageResult',
    components: {
        't-banner': Tbanner
    },
    data() {
        return {
            vendorTxCode: "",
            status: ""
        }
    },
    computed: {
        getStatus() {
            return this.status && this.status.toLowerCase() == "ok";
        }
    },
    mounted() {
        this.vendorTxCode = this.$route.query["VendorTxCode"];
        this.status = this.$route.query["Status"];
    }
}



// WEBPACK FOOTER //
// ./src/components/user/sage-result/layout.js